var React = require('react');

function TiktokInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 6.56311C13.5938 6.59436 12.2812 6.15686 11.1562 5.34436V10.9381C11.1562 13.0631 9.84375 14.9381 7.84375 15.6881C5.875 16.4381 3.625 15.8756 2.25 14.2819C0.84375 12.6569 0.59375 10.3756 1.59375 8.50061C2.59375 6.65686 4.65625 5.62561 6.78125 5.90686V8.71936C5.8125 8.40686 4.75 8.75061 4.15625 9.56311C3.59375 10.4069 3.59375 11.5006 4.1875 12.3131C4.78125 13.1256 5.84375 13.4694 6.78125 13.1569C7.75 12.8444 8.40625 11.9381 8.40625 10.9381V0.000610352H11.1562C11.1562 0.25061 11.1562 0.46936 11.2188 0.71936C11.4062 1.75061 12 2.65686 12.9062 3.21936C13.5 3.62561 14.25 3.84436 15 3.84436V6.56311Z","fill":"#478051"}));
}

TiktokInline.defaultProps = {"width":"15","height":"17","viewBox":"0 0 15 17","fill":"none"};

module.exports = TiktokInline;

TiktokInline.default = TiktokInline;
